<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            Capacitación Educativa y Empresarial
        </h1>
    </div>
</section>

<section class="services-detail-section" #servicesSection>
    <div class="container">
        <div class="services-detail-content">
            <!-- Columna izquierda: Texto + Imagen -->
            <div class="services-left">
                <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                    Formamos equipos para mejorar la gestión financiera de la empresa.
                </h2>
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/4 capacitacion.jpg" alt="Capacitación Educativa y Empresarial">
                </div>
            </div>
            <!-- Columna derecha: Lista de servicios -->
            <div class="services-right">
                <ul class="services-list">
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Charlas en universidades e instituciones.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Talleres de finanzas para PyMEs.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Capacitaciones in-company.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.6s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Formación para directivos.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.7s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Formación para áreas administrativas y financieras.</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>

<app-cta-section></app-cta-section>